import { useEffect } from 'react';
import List from 'components/list/List';
import ListBody from 'components/list/ListBody';
import {
  generatePath,
  useHistory,
  useParams,
  useRouteMatch
} from 'react-router-dom';
import {
  ROUTE_USER_REPORTS_ENTITY,
  ROUTE_USER_REPORTS_ENTITY_REPORT
} from 'routes/RouteList';
import { SessionListItemUser } from 'containers/partials/list-items/SessionListItemUser';
import { Card, CardBody } from 'components/card';
import Message from 'components/message/Message';
import MessageText from 'components/message/MessageText';
import { FormattedMessage } from 'react-intl';
import messages from 'messages';
import FieldInput from 'components/input/FieldInput';
import useSessionSearch from 'hooks/utils/useSessionSearch';
import { SORT_DATA_TYPES } from 'utils/sort';
import SortableListHeader from 'components/list/SortableListHeader';
import { Panel } from 'components/panel';
import { useStore } from 'stores/Store';

const columns = [
  {
    key: 'finishedPercentage',
    label: '',
    sortable: false,
    desc: false,
    dataType: SORT_DATA_TYPES.NUMBER,
    extraProps: { id: 'listItemStatus' } // this prop is only necessary for styles. Most of the times we don't need it
  },
  {
    key: 'name',
    label: 'Session name',
    sortable: true,
    desc: false,
    dataType: SORT_DATA_TYPES.STRING,
    extraProps: { id: 'listItemMainLabel' } // this prop is only necessary for styles. Most of the times we don't need it
  },
  {
    key: 'type',
    label: 'Type',
    sortable: false,
    extraProps: { id: '' } // Empty id === hidden column
  },
  {
    key: 'startdate',
    label: 'Date',
    default: true,
    sortable: true,
    desc: true,
    dataType: SORT_DATA_TYPES.DATE_STRING,
    extraProps: { id: 'listItemLastLabel' } // this prop is only necessary for styles. Most of the times we don't need it
  }
];

function Reports({ entityId }) {
  const reports = useStore(state => state.reports);
  const [{ filteredItems }, setState] = useSessionSearch({
    key: 'name',
    defaultSort: columns.find(c => c.default)
  });
  const active = useRouteMatch([ROUTE_USER_REPORTS_ENTITY]);
  const { push } = useHistory();
  const { sessionId } = useParams();

  useEffect(() => {
    if (reports.length > 0) {
      setState({
        items: reports,
        sort: {
          key: 'startdate',
          desc: true,
          dataType: SORT_DATA_TYPES.DATE_STRING
        }
      });
    }
  }, [reports]);

  return (
    <Panel active={active?.isExact}>
      <div className="p-tabs__tab-header u-margin-top-medium u-padding-bottom-none">
        <FieldInput
          extraClassNames="u-margin-bottom-none"
          rounded
          type="text"
          icon="search-grey"
          iconLeft
          onChange={e => setState({ search: e.target.value })}
        />
      </div>

      {filteredItems?.length > 0 ? (
        <>
          <SortableListHeader
            refactoring
            columns={columns}
            onSort={activeSort => {
              setState({ sort: activeSort });
            }}
          />
          <List>
            <ListBody style={{ paddingBottom: '32px' }}>
              {filteredItems.map(session => {
                return (
                  <SessionListItemUser
                    noMaxHeight
                    id={session.id}
                    key={session.id}
                    session={session}
                    active={sessionId === session.id}
                    onClick={() => {
                      push(
                        generatePath(ROUTE_USER_REPORTS_ENTITY_REPORT, {
                          entityId,
                          sessionId: session.id
                        })
                      );
                    }}
                  />
                );
              })}
            </ListBody>
          </List>
        </>
      ) : (
        <Card secondary>
          <CardBody extraClassNames="u-margin-bottom-none u-padding-vertical-huge">
            <Message emptyState icon="test">
              <MessageText>
                <FormattedMessage {...messages.emptySessionsDataAthlete} />
              </MessageText>
            </Message>
          </CardBody>
        </Card>
      )}
    </Panel>
  );
}

export default Reports;
